import { CursorPaginated } from "@funcional/react-table-ui";
import { IProgramParams, IRefundTransaction, IRefundTransactionProduct } from "../contracts";
import { UseTransactionsOptions } from "../hooks";

export const filterOptions = {
    salesIds: null,
    saleIdsFilter: true,
    headquarterName: null,
    headquarterNameFilter: true,
    establishmentCodes: null,
    establishmentCodesFilter: true,
    productName: null,
    productNameFilter: true,
    refundStatus: null,
    refundStatusFilter: true,
    productCodes: null,
    productCodesFilter: true,
    salesDate: null,
    salesDateFilter: true,
    saleStatus: null,
    saleStatusFilter: true,
    page: 1
};

export function transformStringToDate(options: UseTransactionsOptions | undefined = {}): void {
    if (options.filter?.salesDate) {
      const [day, month, year]: any = options.filter?.salesDate.split("/");
      const transactionDate = new Date(year, month - 1, day);
      options.filter.salesDate = transactionDate as any;
    }
    
    if (options.filter?.salesDate == "Invalid Date") {
      throw new Error("É necessário digitar uma data válida");
    }
}
  
function addSaleError(product: IRefundTransactionProduct, sale): void {
    const containsProblem = product.refundStatus === "NO_RULE" || 
      product.refundStatus === "NO_FORMULA" || 
      !product.refundStatus || 
      product.refundStatus === "0";
  
    if (containsProblem) sale.node.containsProblem = true;
}
  
function removeCanceledProduct(product: IRefundTransactionProduct, sale, index: number) {
    if (product.status === "canceled") {
      sale.node.pbmSalesProducts.splice(index, 1);
    }
}

export function formatTransactions(transactions): CursorPaginated<IRefundTransaction> {
    const transactionsList = transactions?.edges[0]?.nodes;
    const edges = transactionsList?.map((sale) => {
      return {
        node: { ...sale.pbmSales }
      }
    });
    
    transactions.edges = edges;
  
    transactions?.edges?.forEach((sale) => {
      sale.node.saleAmount = 0;
      sale.node.pbmSalesProducts.forEach((product, index: number) => {
        removeCanceledProduct(product, sale, index);
        addSaleError(product, sale);
      });
      
      sale.node.saleAmount = Number(sale.node.saleAmount.toFixed(2));
    });
    
    const result = {
      pageInfo: {
        ...transactions?.pageInfo,
        pageCount: transactions?.edges?.length,
      },
      edges,
    };
  
    return result;
}

export function handleFilter(options: UseTransactionsOptions | undefined = {}, program: IProgramParams): void {
    if (options.gridFilters) {
      const filter: any = options.filter || {};
      filter.programId = program.programId;
      options.gridFilters.forEach((filteredColumn: any) => {
        
        if (filteredColumn.id === "pbmSaleId") {
            handleFilterPagination({filter, filteredColumn, item: "salesIds"});
        } 
        if (filteredColumn.id === "establishmentCode") {
            handleFilterPagination({filter, filteredColumn, item: "establishmentCodes"});
        } 
        if (filteredColumn.id === "EAN") {
            handleFilterPagination({filter, filteredColumn, item: "productCodes"});
        }
        if (filteredColumn.id === "transactionDate") {
            handleFilterPagination({filter, filteredColumn, item: "salesDate"});
        }
        if (filteredColumn.id === "canceledTransactionDate") {
            handleFilterPagination({filter, filteredColumn, item: "saleStatus"});
        }
        if (filteredColumn.id === "Processamento") {
            handleFilterPagination({filter, filteredColumn, item: "refundStatus"});
        }
        if (filteredColumn.id === "Produto") {
            handleFilterPagination({filter, filteredColumn, item: "productName"});
        }
        if (filteredColumn.id === "after") filter.after = filteredColumn.value;
        if (filteredColumn.id === "before") filter.before = filteredColumn.value;
        });
        
        options.filter = filter;
    }
}
  
function handleFilterPagination({filter, filteredColumn, item}) {
    filter[item] = filteredColumn.value;
  
    if (filterOptions[item + "Filter"]) {
      filterOptions[item] = filteredColumn.value;
      filterOptions[item + "Filter"] = false;
      filterOptions.page = 1;
    }
  
    if (filterOptions[item] !== filteredColumn.value) {
      filterOptions.page = 1;
      filterOptions[item] = filteredColumn.value;
    }
}